import { useState } from 'react';

import './sales-panels.scss';

import { useConsultants } from '../../../../api/hooks/sales/useConsultants';
import { useCouponEntityQuery } from '../../../../api/hooks/sales/useCouponEntityQuery';
import { useCouponRedemptions } from '../../../../api/hooks/sales/useCoupons';
import { getCouponColumnDefinition, COUPON_TABS } from '../../../../schema/sales/coupon.schema';
import { EntityTable } from '../../../common/entity-table/EntityTable';
import { Modal } from '../../../common/modal/Modal';

const RedemptionLog = ({ couponId }) => {
  const { redemptions, isLoading } = useCouponRedemptions(couponId);

  if (isLoading) return <div className="sales-panel__loading">Loading...</div>;

  return (
    <div className="sales-panel__table-wrap">
      <table className="sales-table">
        <thead>
          <tr>
            <th>Order</th>
            <th>Customer</th>
            <th>Discount Applied</th>
            <th>Date</th>
          </tr>
        </thead>
        <tbody>
          {redemptions.length === 0 && (
            <tr>
              <td colSpan={4} className="sales-table__empty">
                No redemptions yet
              </td>
            </tr>
          )}
          {redemptions.map((r) => (
            <tr key={r.id}>
              <td>{r.orderNumber}</td>
              <td>{r.customerEmail ?? r.customerId ?? '-'}</td>
              <td>R{parseFloat(r.discountApplied).toFixed(2)}</td>
              <td>{new Date(r.redeemedAt).toLocaleDateString('en-ZA')}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export const CouponsPanel = () => {
  const couponQuery = useCouponEntityQuery();
  const { consultants } = useConsultants();
  const [logCoupon, setLogCoupon] = useState(null);

  const wrappedColumnDef = (onEdit, onView, onDelete) =>
    getCouponColumnDefinition(onEdit, onView, onDelete, setLogCoupon);

  return (
    <>
      <EntityTable
        query={couponQuery}
        getColumnDefinition={wrappedColumnDef}
        entityTabs={COUPON_TABS(consultants)}
        entityName="Coupon"
        canView={false}
      />

      <Modal
        title={logCoupon ? `${logCoupon.code}: Redemption Log` : ''}
        isOpen={!!logCoupon}
        onClose={() => setLogCoupon(null)}
        width={680}
        minHeight="460px"
      >
        {logCoupon && <RedemptionLog couponId={logCoupon.id} />}
      </Modal>
    </>
  );
};
